import * as CookieConsent from "vanilla-cookieconsent";

export default function CookiePreferencesButton({ className }) {
  return (
    <button
      className={className}
      onClick={() => CookieConsent.showPreferences()}
      type="button"
    >
      Preferenze cookie
    </button>
  );
}
